import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-notification-container container" }
const _hoisted_2 = { class: "app-notification-container app-notification-container--bottom container" }

import { appNotifications } from '@/services/notification.app'
import AppNotification from '@/app/components/AppNotification.vue'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotificationContainer',
  setup(__props) {

const topNotifications = computed(() =>
  appNotifications.notifications.filter((n) => !n.compact),
)
const compactNotifications = computed(() =>
  appNotifications.notifications.filter((n) => n.compact),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "app-notification-container__transition" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topNotifications.value, (notification) => {
            return (_openBlock(), _createBlock(AppNotification, {
              key: notification.id,
              variant: notification.variant,
              actions: notification.actions,
              confetti: notification.confetti,
              onClose: ($event: any) => (_unref(appNotifications).dismiss(notification.id))
            }, _createSlots({
              message: _withCtx(() => [
                _createTextVNode(_toDisplayString(notification.message), 1)
              ]),
              _: 2
            }, [
              (notification.title)
                ? {
                    name: "title",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(notification.title), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["variant", "actions", "confetti", "onClose"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, { name: "app-notification-container__transition" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compactNotifications.value, (notification) => {
            return (_openBlock(), _createBlock(AppNotification, {
              key: notification.id,
              variant: notification.variant,
              actions: notification.actions,
              compact: true
            }, {
              message: _withCtx(() => [
                _createTextVNode(_toDisplayString(notification.message), 1)
              ]),
              _: 2
            }, 1032, ["variant", "actions"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})